import {
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup
} from "@mui/material";
import { SelectFieldProps } from "./SelectField";


interface RadioSelectFieldProps extends SelectFieldProps {
    horizontal?: boolean;
}


export const RadioSelectField = ({
    name,
    value,
    label = "",
    options,
    onChange,
    warning = "",
    helpText = "",
    formik = false,
    disabled = false,
    autoFocus = false,
    horizontal = false,
}: RadioSelectFieldProps) => {

    return (
        <FormControl className="form-field field-radio-select" style={{gap: "4px"}}>

            {label ? <FormLabel>{label}</FormLabel> : null}
            {helpText ? <span className="help-text">{helpText}</span> : null}

            <RadioGroup
                name={name}
                value={value}
                style={{flexDirection: horizontal ? "row" : "column"}}
                onChange={e => onChange(e)}>

                {options?.map((option, i) => {
                    var labelId = `${name}-${i}}`
                    var help = null
                    if (typeof option?.help === "string") {
                        help = option.help
                    } 
                    // if (typeof option?.help === "object" && option.help?.label) {
                    //     help = option.help.label
                    // } 
                    return (
                        <FormControlLabel
                            key={i}
                            value={option.value}
                            label={(
                                <div>
                                    <label htmlFor={labelId}>{option.label}</label>
                                    {help ? <span className="help-text">{help}</span> : null}
                                </div>
                            )}
                            disabled={disabled}
                            control={
                                // Apply autoFocus to the first option
                                <Radio id={labelId} inputProps={{autoFocus: i === 0 ? autoFocus : false}} />
                            } />
                    )
                })}
            </RadioGroup>

            {warning !== false && typeof warning === "string" ? <span className="warning">{warning}</span> : null}

        </FormControl>
    )
}